<template>
    <form role="form">
        <div class="container-fluid" style="overflow-y: scroll; height: 500px;">      
            <div class="row">

                <!--___________________________DATI GENERALI___________________________-->
                <div class="col-md-8">
                    <label class="text-left">{{datiGeneraliLbl}}</label>
                    <div style="display: inline-block; border-top: 1px solid lightgray; content: ''; top: 20px; right: 10em; vertical-align: top; bottom: 0; width: 100%;"> </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <div class="col-sm-5">
                                    <span class="align-middle">{{riferimentoLbl}}</span>
                                </div>
                                <div class="col-sm-7">
                                    <input readonly type="text" v-model="riferimentoValue"  id="riferimentoId" class="form-control form-control-sm"/>
                                </div>
                            </div>
                            <cfg v-if="!this.$root.ecIntegrationActive" cid="shopCart.tipoOrdine" tag='div' class="form-group">
                                <div class="col-sm-5">
                                    <span style="vertical-align: middle">{{tipoOrdineLbl}}</span>
                                </div>
                                <div class="col-sm-7">
                                    <v-select :label="'type'" id="tipoOrdineId" :disabled="tipoOrdineDisabled"  style="width: 100%;" :options="tipoOrdineOptionsValue" v-model="tipoOrdineValue" @input="onOrderTypeChange(tipoOrdineValue)" :placeholder="$Jed.firstUpperTranslate('select')+' '+$Jed.firstUpperTranslate('order type')"></v-select>
                                </div>
                            </cfg>
                        </div>

                        <div class="col-sm-6">
                            <cfg v-if="!this.$root.ecIntegrationActive" cid="shopCart.vsRif" tag='div' class="form-group">
                                <div class="col-sm-5">
                                    <span style="vertical-align: middle">{{vsRiferimentoLbl}}</span>
                                </div>
                                <div class="col-sm-7">
                                    <input type="text" v-model="vsRiferimentoValue"  id="vsRiferimentoId" class="form-control"/>
                                </div>
                            </cfg>
                            <cfg class="form-group" cid="shopCart.scontoBase" v-if="!$root.token.hidePrices && showScontoBase" tag='div'>
                                <div class="col-sm-5">
                                    <span style="vertical-align: middle">{{scontoBaseLbl}}</span>
                                </div>
                                <div class="col-sm-7">
                                    <input disabled type="number" v-model.number="scontoBaseValue"  id="scontoBaseId" class="form-control"/> 
                                </div>
                            </cfg>
                        </div>
                    </div>

                    <div v-if="!this.$root.ecIntegrationActive" class="row">
                        <cfg cid="shopCart.note" tag='div' class="col-sm-12 form-group">
                            <div class="controls col-sm-2">
                                <span class="">{{noteLbl}}</span>
                            </div>
                            <div class="controls col-sm-10">
                                <textarea id="noteId" rows="2" class="form-control" v-model="noteValue" data-role="textarea" style="max-width: 100%; max-height: 138px;"></textarea>
                            </div>
                        </cfg>
                    </div>
                </div>

                <!--___________________________IMPORTO___________________________-->
                <cfg cid="shopCart.importo" tag='div'>
                    <div v-if="!$root.token.hidePrices" class="col-md-4">
                        <label class="text-left">{{importoLbl}}</label>
                        <div style="display: inline-block; border-top: 1px solid lightgray; content: ''; top: 20px; right: 10em; vertical-align: top; bottom: 0; width: 100%;"></div>
                        <div class="form-group">
                            <div class="col-sm-12">
                                <input readonly id="importoId" class="form-control" v-model="importoValue"  type="text">
                            </div>
                        </div>
                        <div class="form-group">
                            <span class="align-middle">&nbsp;</span>
                        </div>
                    </div>
                </cfg>
            </div>

            <!--___________________________TABELLA PRODOTTI___________________________-->
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <div style="padding: 5px;">
                            <grid :columns="gridProdAttributesCfg.columns"
                                :source.sync="arrayToTable" :options="options" :others="others"
                                    :lang="$root.token.idLingua" :name="gridProdAttributesCfg.title">
                            </grid>
                        </div>
                    </div>
                </div>
            </div>

            <!--___________________________PULSANTI___________________________-->
            <div class="row">
                <div class="col-md-7">
                    <div v-if="!this.$root.ecIntegrationActive">
                        <div class="controls col-sm-3">
                            <button @click.prevent="forwardClick"  class="btn btn-primary-default" style="width: 130px">{{$Jed.firstUpperTranslate('continue')}}</button>
                        </div>
                        <div v-if="$Behaviors.addProductFromCart" class="controls col-sm-3">
                            <button @click.prevent="addProductClick"  class="btn btn-primary-default" style="width: 140px">{{$Jed.firstUpperTranslate('add')+' '+$Jed.translate('product')}}</button>
                        </div>
                        <div v-if="$Behaviors.loadOrderItemsFromExcel" class="controls col-sm-3">
                            <button @click.prevent="loadFromExcelClick"  class="btn btn-primary-default" style="width: 140px">{{$Jed.firstUpperTranslate('upload file')}}</button>
                        </div>
                        <div v-if="$Behaviors.availabilityStatus.updateButton" class="controls col-sm-3">
                            <button @click.prevent="$root.updateAvailability()"  class="btn btn-primary-default" style="width: 160px">{{$Jed.firstUpperTranslate('update availability')}}</button>
                        </div>
                    </div>

                    <cfg cid="shopCart.nuovoOrdineBtn" tag='div'>
                        <div class="controls col-sm-3">
                            <button :disabled="arrayToTable.length == 0" @click.prevent="cleanShopCartClick"  class="btn btn-danger" style="width: 140px">{{$Jed.firstUpperTranslate('new order')}}</button>
                        </div>
                    </cfg>
                </div>
                <div class="col-md-5">
                    <div v-if="this.$root.ecIntegrationActive">
                        <button :disabled="isSyncing" @click.prevent="cartSend" class="btn btn-success" style="width: 100%">{{$Jed.firstUpperTranslate('send')}}</button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md">&nbsp;
                </div>
            </div>                        
        </div>

        <purchasePopup id="purchasePopup" :chooseQty="chooseQty" :purchaseSid="purchaseSid" :purchaseDes="purchaseDes" 
            :purchasePrice="purchasePrice" :popupHeight="popupHeight" :product="product" :arrayToTable="arrayToTable" :tableConfigs="gridProdAttributesCfg">
        </purchasePopup>
    </form>
</template>

<script>

import Grid from '../../dynamic/jqwGridWrapper/jqwGridWrapper.vue'
import FormMixin from '../../dynamic/inputWrapper/formMixin.js'
import table_resize_mixin from "../../../mixins/table_resize_mixin.js";
import purchasepopup_mixin from "../../../mixins/purchasepopup_mixin.js";
import vSelect from "../../dynamic/vueSelectWrapper/components/Select.vue"
import PurchasePopup from '../../others/PurchasePopup.vue'
import { eventBus } from "../../../eventbus";
import Cfg from "../../dynamic/ConfigurableComponent.vue";

export default {
    mixins: [FormMixin, purchasepopup_mixin],
    components: {
        Grid,
        vSelect,
        PurchasePopup,
        Cfg
    }, 
    data: function () {
        var vm = this;
        return {
            arrayToTable: [],

            datiGeneraliLbl: vm.$Jed.firstUpperTranslate('general data'),
            manutenzioneLbl: vm.$Jed.firstUpperTranslate('Manutenzione'),
            importoLbl: vm.$Jed.firstUpperTranslate('amount'),
            riferimentoLbl: vm.$Jed.firstUpperTranslate('reference'),
            vsRiferimentoLbl: vm.$Jed.firstUpperTranslate('your ref'),
            tipoOrdineLbl: vm.$Jed.firstUpperTranslate('order type'),
            scontoBaseLbl: vm.$Jed.firstUpperTranslate('base discount'),
            noteLbl: vm.$Jed.firstUpperTranslate('note',2),
            riferimentoValue: vm.$root.shopCartData ? vm.$root.shopCartData.riferimento : '',
            vsRiferimentoValue: vm.$root.shopCartData ? vm.$root.shopCartData.vostroRif : '',            
            tipoOrdineOptionsValue: [],
            tipoOrdineValue: {},
            scontoBaseValue: vm.$root.shopCartData.scontoBase,
            showScontoBase: true,
            riduzioneScontoValue: 0,
            noteValue: vm.$root.shopCartData ? vm.$root.shopCartData.note : '',
            importoValue: vm.$root.shopCartData ? vm.$root.shopCartData.importo : '',

            options: {
                    columnsresize: true,
                    columnsreorder: true,
                    columnsmenu: vm.$Components.TabellaProdotti.options.columnsmenu,
                    rowsheight: 24,
                    theme: "light",
                    width: "100%",
                    selectionmode: "none",
                    showfilterrow: false,
                    filterable: true,
                    sortable: true,
                    pageable: false,
                    autoheight: false,
                    height: 220,
                    rowdetails: true,
                    rowdetailstemplate: {
                        rowdetails:
                            "<div style='margin: 10px 10px 10px 0px;'>Override this</div>",
                        rowdetailsheight: 250 /* ! 230 + 20 ! */
                    },
                    /* configurando una griglia ricorsiva, impostare rowdetailstemplate.rowdetails height uguale all'altezza della griglia innestata ... 
                    ... (in questo caso definita con autoheight: false e height: 230), + 20px per tenere in considerazione e margini di default */
                    initrowdetails: "nested",
                    rendered: null
            },
            others:{
                adaptColumns: true
            },
            gridProdAttributesCfg: {
                    ID: "gridProdAttributesId",
                    title: "TabellaProdotti",
                    label_title: "",
                    visible: true,
                    
                    columns: {
                    configs:{
                        remove: {
                            text:"",
                            position: 1,
                            width: "3%", 
                            searchable: false,
                            filterable: false,
                            sortable: false,
                            align: "center",
                            iconcolumn: true,                           
                            geticonclass: function(data_row, index) {
                                return vm.$root.icons.close;
                            },
                            onclick: function(obj) {
                                var ok = function(){
                                    try{
                                        var products = vm.$root.shopCartData.prodotti;                               
                                        const idx = products.indexOf(obj.refObj);                                
                                        if (idx !== -1) {
                                            products.splice(idx, 1);
                                        }

                                        const index = vm.arrayToTable.indexOf(obj);                                
                                        if (index !== -1) {
                                            vm.arrayToTable.splice(index, 1);
                                        }

                                        //rimuovo effettivamente la riga ordine dal loki
                                        var rec = vm.reg_order_items.find({'id': obj.refObj.id})[0]
                                        if(rec)vm.reg_order_items.remove(rec)

                                        if(vm.arrayToTable.length == 0){ //se ho rimosso tutte le righeordine, rimuovo anche l'ordine
                                            var reco = vm.reg_orders.find({'id': vm.$root.shopCartData.id})[0]
                                            if(reco)vm.reg_orders.remove(reco)
                                        }
                                        
                                        //alla fine delle op sui loki di ordini e righeordine salvo il loki db e chiedo la sync
                                        vm.$root.dbRegistry.saveDatabase(function(err) {
                                            if (err) {
                                                console.log("saveDatabase - error : " + err);
                                            } else {
                                                if(!vm.$root.preferences.useOffline)vm.$Sync.triggerUpdate() //nuova gestione sync nell'online
                                                console.log("ShopCart: remove row - saveDatabase - database aggiornato");
                                                
                                                if(vm.arrayToTable.length == 0){ //se ho rimosso tutte le righe, creo un nuovo carrello
                                                    console.log("ShopCart - creo nuovo carrello");
                                                    vm.$root.newCart().then(()=>{
                                                        vm.updateData();
                                                    })
                                                }
                                                eventBus.$emit("cartFilled",vm.$root.shopCartData.prodotti.length);
                                            }
                                        });

                                        vm.refreshGrid();
                                        this.close();
                                    }catch(e){
                                        eventBus.$emit('alert', {
                                            message: vm.$Jed.firstUpperTranslate("An error occurred in deleting order row. Please contact admin: %1$s", null, {
                                                key: null,
                                                string: e
                                            }), 
                                            type: "warning",
                                            action: ''
                                        })
                                    }
                                },
                                no = function(){
                                    this.close();
                                },
                                e = {
                                    message: vm.$Jed.firstUpperTranslate('Are you sure you want to delete the row with product %1$s?',null,{
                                        key: null,
                                        string: [obj.cod+' - '+obj.descr]
                                    }),
                                    ok: ok,
                                    no: no
                                }
                                eventBus.$emit("confirm", e)
                            }
                        },
                        codice: {
                            text: vm.$Jed.firstUpperTranslate('code'), //il nuovo
                            position: 2,
                            visible: true,
                            editable: false,
                            width: "9%",
                            searchable: false,
                            sorting: true,
                            datafield: "cod"
                        },
                        descr: {
                            text: vm.$Jed.firstUpperTranslate('description'),
                            position: 2,
                            visible: true,
                            editable: false,
                            width: vm.$root.token.hidePrices ? "24%" : "25%",
                            searchable: false,
                            sorting: true,
                            datafield: "descr"
                        },
                        sost: {
                            text: vm.$Jed.firstUpperTranslate('substitutes'), //il "sostituito", cioè il vecchio
                            position: 3,
                            visible: true,
                            editable: false,
                            width: "9%",
                            searchable: false,
                            sorting: true,
                            datafield: "sost"
                        },
                        qty: {
                            text: vm.$Jed.firstUpperTranslate('qty'),
                            position: 4,
                            visible: true,
                            editable: false,
                            width: "7%",
                            searchable: false,
                            sorting: true,
                            datafield: "qty",
                            cellsrenderer: function (data_row, datafield, value) {
                                if(value){
                                    var v = value.split('>')[value.split('>').length-1].trim()
                                    return '<div style="display: table; width: 100%; height: 100%"><div style="display: table-cell; vertical-align: middle; text-align: center; "><span style="margin-right: 6px">' + '<i class="icon-modificare"></i> '+ Number(v).toLocaleString() + '</span></div></div>';
                                }
                            },
                            onclick: function(obj, event) {
                                console.log(obj)
                                //il click sull'icona del carrello non deve innescare la chiusura del popup di acquisto
                                console.log(event)
                                event.stopPropagation(); //fermo la propagazione dell'evento di click in modo che non si inneschi la chiusura del popup
                                $('#purchasePopup').mousedown(function(event){ //il click sull'area che comprende il popup non ne innesca la chiusura
                                    console.log('purchasePopup click event')
                                    event.stopPropagation();
                                });
                                
                                $('.popup-arrow').css('top', '2px')
                                $('.popup-arrow-border').css('top', '2px')

                                vm.minQuantity = obj.mqt;
                                var nqty = obj.qty ? obj.qty.split('>')[obj.qty.split('>').length-1].trim() : ''
                                vm.product = {
                                    cod: obj.cod,
                                    qty: nqty!='' && nqty >= obj.mqt ? nqty : obj.mqt,
                                    descr: obj.descr,
                                    unitmis: obj.unitmis, 
                                    refObj: obj.refObj,
                                    csy: vm.$root.token.valuta
                                };
                                console.log(vm.product)
                                if(obj.qca){
                                    $("#popupquantita2Id"+vm.gridProdAttributesCfg.title).val(obj.qca);
                                }else{
                                    $("#popupquantita2Id"+vm.gridProdAttributesCfg.title).val(vm.product && vm.product.qty ? vm.product.qty : 1);
                                }
                                $("#popupquantita2Id"+vm.gridProdAttributesCfg.title).attr('min', obj.mqt);
                                $("#popupquantita2Id"+vm.gridProdAttributesCfg.title).attr('max', vm.maxQuantity);
                                vm.manageCounter();

                                //gestione posizionamento popup: compare in alto rispetto all'icona carrello e la freccina è nella parte bassa del popup
                                var tabWrapCont = $("#TabellaProdotti"),
                                    containerH = tabWrapCont.css('height'),
                                topcont = event.clientY - parseInt(containerH) - 30;
                                $('.popup-arrow').css('top', '168px')
                                $('.popup-arrow-border').css('top', '168px')
                                
                                if(vm.chooseQty){
                                    vm.chooseQty = false
                                }else{
                                    vm.chooseQty = true
                                    $("#purchasePopup").css('top', topcont); 
                                    $("#purchasePopup").css('left', event.clientX - 20); 

                                    vm.purchaseDes = obj.descr
                                    vm.purchaseSid = obj.cod
                                    var pp = obj.uprice /* Number(obj.uprice.replace('€','')) */
                                    pp = Number(pp).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                                    vm.purchasePrice = !vm.$root.token.hidePrices ? pp + " " + vm.$root.token.valuta : null
                                    vm.popupHeight = vm.purchasePrice != null ? 'height: 220px;' : 'height: 200px;'
                                } 
                            }
                        },
                        unitmis: {
                            text: vm.$Jed.firstUpperTranslate('unit of measure'),
                            position: 5,
                            visible: true,
                            editable: false,
                            width: "7%",
                            searchable: false,
                            sorting: true,
                            datafield: "unitmis"
                        },
                        originprice: {
                            text: vm.$Jed.firstUpperTranslate('price'),
                            position: 6,
                            visible: true,
                            hidden: vm.$root.token.hidePrices,
                            editable: false,
                            width: "8%",
                            searchable: false,
                            sorting: true,
                            datafield: "originprice",
                            cellsalign: 'right', 
                            tobecellsrenderered: function(datarow, row, columnfield, value, defaulthtml, columnproperties){
                                if(value && value != ""){
                                    var csy = datarow.csy ? datarow.csy : vm.$root.token.valuta
                                    return '<div style="display: table; width: 100%; height: 100%"><div style="display: table-cell; vertical-align: middle; text-align: ' + columnproperties.cellsalign + '"><span style="margin-right: 6px">' + Number(value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' ' + csy + '</span></div></div>';
                                } else {
                                    return ""
                                }
                            }
                        },
                        uprice: {
                            text: vm.$Jed.firstUpperTranslate('unitary price'),
                            position: 7,
                            visible: true,
                            hidden: vm.$root.token.hidePrices,
                            editable: false,
                            width: "8%",
                            searchable: false,
                            sorting: true,
                            datafield: "uprice",
                            cellsalign: 'right', 
                            tobecellsrenderered: function(datarow, row, columnfield, value, defaulthtml, columnproperties){
                                if(value && value != ""){
                                    var csy = datarow.csy ? datarow.csy : vm.$root.token.valuta
                                    return '<div style="display: table; width: 100%; height: 100%"><div style="display: table-cell; vertical-align: middle; text-align: ' + columnproperties.cellsalign + '"><span style="margin-right: 6px">' + Number(value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' ' + csy + '</span></div></div>';
                                } else {
                                    return ""
                                }
                            }
                        },                        
                        totprice: {
                            text: vm.$Jed.firstUpperTranslate('Prezzo Totale'),
                            position: 8,
                            visible: true,
                            hidden: vm.$root.token.hidePrices,
                            editable: false,
                            width: "8%",
                            searchable: false,
                            sorting: true,
                            datafield: "totprice",
                            cellsalign: 'right', 
                            tobecellsrenderered: function(datarow, row, columnfield, value, defaulthtml, columnproperties){
                                if(value && value != ""){
                                    var csy = datarow.csy ? datarow.csy : vm.$root.token.valuta
                                    return '<div style="display: table; width: 100%; height: 100%"><div style="display: table-cell; vertical-align: middle; text-align: ' + columnproperties.cellsalign + '"><span style="margin-right: 6px">' + Number(value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' ' + csy + '</span></div></div>';
                                } else {
                                    return ""
                                }
                            }
                        },
                        scArt:{
                            text: vm.$Jed.firstUpperTranslate('product discount'),
                            position: 11,
                            visible: true,
                            editable: false,
                            width: "9%",
                            searchable: false,
                            sorting: true,
                            datafield: "scArt"
                        },
                        codlinea: {
                            text: vm.$Jed.firstUpperTranslate('line code'),
                            position: 8,
                            visible: true,
                            editable: false,
                            width: "9%",
                            searchable: false,
                            sorting: true,
                            datafield: "codlinea"
                        },
                        codmacch: {
                            text: vm.$Jed.firstUpperTranslate('machine code'),
                            position: 9,
                            visible: true,
                            editable: false,
                            width: "9%",
                            searchable: false,
                            sorting: true,
                            datafield: "codmacch"
                        },
                        desmacch: {
                            text: vm.$Jed.firstUpperTranslate('machine description'),
                            position: 10,
                            visible: true,
                            editable: false,
                            width: "22%",
                            searchable: false,
                            sorting: true,
                            datafield: "desmacch"
                        },
                        noteRig: {
                            text: vm.$Jed.firstUpperTranslate('row notes'),
                            position: 12,
                            visible: true,
                            editable: true,
                            editPopupCfg:{
                                title: this.$Jed.firstUpperTranslate('edit'),
                                content: this.$Jed.firstUpperTranslate('insert note for order row. \n Product code:'),
                                ex: this.setRowNote,
                                popCond: this.showNotePopup,
                                popStyle: {'top':'0px','left': (window.innerWidth-700)+'px', 'max-width': '350px', width: '335px', 'font-size': 'small', height: 'max-content'},
                                arrStyle: {'display': 'none'}
                            },
                            width: "10%",
                            searchable: false,
                            sorting: true,
                            datafield: "noteRiga"
                        },
                        statoDis: {
                            text: vm.$Jed.firstUpperTranslate('availability'),
                            position: 1,
                            visible: true,
                            editable: true,
                            width: "3%",
                            searchable: false,
                            sorting: true,
                            datafield: "statoDisponibilità",
                            iconcolumn: true,
                            customicon: true,
                            setcustomicon: function(data_row) {
                                if(vm.$Behaviors.availabilityStatus.semaphore){
                                    var sem = Object.values(vm.$Behaviors.availabilityStatus.semaphore).find(s => s.value == data_row.statoDis);
                                    if(data_row.statoDis && sem){
                                        return  "<i class='"+vm.$root.icons.circle + " icon-stack-1x' style='color:"+sem.color +";'></i>"; 
                                    }else{
                                        return  "<i class='"+vm.$root.icons.circle + " icon-stack-1x' style='color: grey;'></i>"; 
                                    }
                                }
                            }
                        }
                    }
                }
            },
            tipoOrdineDisabled: false,
            chooseQty: false,
            purchaseDes: '',
            purchasePrice: '',
            purchaseSid: '',
            minQuantity: 1,
            maxQuantity: 9999999,
            product: null,
            popupHeight: '',
            reg_order_items: vm.$root.dbRegistry.getCollection('orderItems'),
            reg_orders: vm.$root.dbRegistry.getCollection('orders'),
            showNotePopup: false,
            isSyncing: true      
        }
    },
    watch: {
        importoValue: function(){
            this.importoValue = Number(this.importoValue) ? Number(this.importoValue).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : this.importoValue;
        }
    },
    created:  function()  {
        var vm = this;
        var idC = vm.$root.token.idCliente;
        vm.$root.getOrderTypeOptions(idC).then(result=>{
            vm.tipoOrdineOptionsValue = result
            vm.refreshGrid();
            var tipoOrdineItem = vm.tipoOrdineOptionsValue ? vm.tipoOrdineOptionsValue.find(o => o.type == vm.$root.shopCartData.tipoOrdine ) : ''; 
            
            if(vm.tipoOrdineOptionsValue && vm.tipoOrdineOptionsValue.length == 1){ //se c'è solo un tipoOrdine
                vm.tipoOrdineDisabled = true; //disabilito il menù a tendina
            }
            vm.tipoOrdineValue = tipoOrdineItem != null ? tipoOrdineItem : vm.tipoOrdineOptionsValue[0]; 
        })
              

        eventBus.$on("gotChanges",()=>{
            var reg_orders = vm.$root.dbRegistry.getCollection('orders'),
                reg_order_items = vm.$root.dbRegistry.getCollection('orderItems'),
                order = vm.$root.shopCartData ? reg_orders.find({'$loki': vm.$root.shopCartData.$loki}) : '', //uso $loki perchè questo serve per aggiornare le schermate quando ho inserito un prodotto in carrello e ancora ci sono gli id provvisori (negativi) per ordine e righeordine
                difference = [];
            console.log("gotChanges")
            if(order && order[0]){
                vm.$root.shopCartData.id = order[0].id; //imposto il nuovo id per la struttura che rappresenta il carrello (cioè ShopCartData) così posso usare questa proprietà per recuperare il record dall'idb quando serve
                vm.riferimentoValue = order[0].id; //aggiorno i campi della videata che potrebbero avere subito delle modifiche con la sync bi-dir

                var order_items = reg_order_items.find({oid: order[0].id});
                if(order_items.length>0){
                    var products = vm.$root.shopCartData.prodotti;
                    if(products.length>0){
                        vm.isSyncing = false
                        //ho aggiunto altri prodotti e devo aggiornare la struttura carrello
                        if(products.length < order_items.length){
                            console.log("prodotti aggiunti")
                            //in difference avrò una copia dell'array con i soli elementi che passano il test
                            difference = order_items.filter(oi=>{
                                //prodotti che sono nell'ordine su db ma non sono ancora nella struttura carrello
                                return products.every(el=>{ 
                                    //torna vero solo se tutti gli elementi nell'array passano la condizione
                                    //falso se almeno un elemento dell'array non passa la condizione
                                    return el.id != oi.id
                                })
                            })
                        }else if(products.length > order_items.length){
                            console.log("prodotti rimossi")
                            //caso in cui siano state rimosse delle righe nello scenario di ecp (ovvero righe correttamente inserite nel carrello bcs)
                            for(var i=0; i<order_items.length; i++){
                                const idx = products.findIndex(p => p.id != order_items[i].id);
                                //rimuovo le righe dalla struttura carrello                                
                                if (idx !== -1) {
                                    products.splice(idx, 1);
                                }

                                const index = vm.arrayToTable.findIndex(e => e.refObj.id != order_items[i].id);
                                //rimuovo le righe dalla griglia
                                if (index !== -1) {
                                    vm.arrayToTable.splice(index, 1);
                                }
                            }

                            if(vm.arrayToTable.length == 0){ //se ho rimosso tutte le righe, creo un nuovo carrello
                                console.log("ShopCart - gotChanges - creo nuovo carrello");
                                vm.$root.newCart().then(()=>{
                                    vm.updateData();
                                })
                            }         
                        }

                        for(var i = 0; i < difference.length; i++){
                            var orderItem = {}
                            orderItem.id = difference[i].id;
                            orderItem.idOrder = difference[i].oid;
                            orderItem.codiceProd = difference[i].pid;           
                            orderItem.codSost = difference[i].spi;   
                            orderItem.descrizione = difference[i].ide;         
                            orderItem.unitaMisura = difference[i].uni; 
                            orderItem.quantita = difference[i].qty;
                            orderItem.prezzoUnitario = difference[i].unp != null ? difference[i].unp : 0; 
                            orderItem.prezzoOriginario = difference[i].ulp != null ? difference[i].ulp : 0; 
                            orderItem.statoProdotto = difference[i].sta; 
                            orderItem.dataModifica = difference[i].mdt; 
                            orderItem.dataUltimaModifica = difference[i].udt
                            orderItem.codlinea = difference[i].ldi
                            orderItem.codmacch = difference[i].mpi
                            orderItem.desmacch = difference[i].mde  
                            orderItem.scontoCliente = difference[i].cd1
                            orderItem.scontoArticolo = difference[i].cd2
                            orderItem.noteRiga = difference[i].not
                            orderItem.statoDisponibilità = difference[i].qas
                            products.push(orderItem) //inserisco nella struttura carrello i prodotti che mancano
                        }

                        //imposto i nuovi id per i prodotti nella struttura carrello
                        //potrebbe essere cambiata anche la quantità o le note quindi aggiorno anche quelle
                        for(var i = 0; i < order_items.length; i++){
                            for(var j = 0; j < products.length; j++){
                                if(order_items[i].pid == products[j].codiceProd){
                                    products[j].id = order_items[i].id
                                    products[j].quantita = order_items[i].qty
                                    products[j].noteRiga = order_items[i].not
                                    products[j].statoDisponibilità = order_items[i].qas
                                }
                            }
                        }
                    }else{
                        for(var i = 0; i < order_items.length; i++){
                            var orderItem = {}
                            orderItem.id = order_items[i].id;
                            orderItem.idOrder = order_items[i].oid;
                            orderItem.codiceProd = order_items[i].pid;           
                            orderItem.codSost = order_items[i].spi;   
                            orderItem.descrizione = order_items[i].ide;         
                            orderItem.unitaMisura = order_items[i].uni; 
                            orderItem.quantita = order_items[i].qty;
                            orderItem.prezzoUnitario = order_items[i].unp != null ? order_items[i].unp : 0; 
                            orderItem.prezzoOriginario = order_items[i].ulp != null ? order_items[i].ulp : 0; 
                            orderItem.statoProdotto = order_items[i].sta; 
                            orderItem.dataModifica = order_items[i].mdt; 
                            orderItem.dataUltimaModifica = order_items[i].udt
                            orderItem.codlinea = order_items[i].ldi
                            orderItem.codmacch = order_items[i].mpi
                            orderItem.desmacch = order_items[i].mde  
                            orderItem.scontoCliente = order_items[i].cd1
                            orderItem.scontoArticolo = order_items[i].cd2
                            orderItem.noteRiga = order_items[i].not
                            orderItem.statoDisponibilità = order_items[i].qas
                            products.push(orderItem);  
                        }
                    }
                    vm.refreshGrid();
                }
            }
            vm.$root.getOrderTypeOptions(idC).then(discounts=>{
                vm.scontoBaseValue = vm.$root.shopCartData.scontoBase //discounts.length>0 ? discounts[0].value === 100.0 ? 0 : discounts[0].value : 0;
                vm.refreshGrid();
            })
        })

        eventBus.$on("chooseQtyChanged", (cq)=>{
            vm.chooseQty = cq;
        })

        eventBus.$on("refreshGrid",()=>{
            vm.refreshGrid();
        })

        $(window).mousedown(function(e) { //al rilascio del mouse su una qualunque area della finestra chiudo il popup di acquisto
            vm.closePopups();
        });
    },
    mounted: function() {
        this.updateData()
        var tipoOrdineItem = this.tipoOrdineOptionsValue ? this.tipoOrdineOptionsValue.find(o => o.type == this.$root.shopCartData.tipoOrdine) : ''
        this.tipoOrdineValue = tipoOrdineItem != null ? tipoOrdineItem : this.tipoOrdineOptionsValue[0];

        //aggiorna disponibilità quando il carrello viene aperto
        if(this.$Behaviors.erpgInterface){
            this.$root.updateAvailability();
        }

        console.log('ShopCart - mounted: ', this.$root.shopCartData)
        if (this.$root.shopCartData.prodotti.length > 0 && this.$root.shopCartData.id > 0) {
			this.isSyncing = false;
		}
    },
    methods: {
        updateData(source) {
            console.log('ShopCart - updateData', this.$root.shopCartData)
            if(this.$Behaviors.erpgInterface && source && source=='archivio'){
                console.log('carica ordine da archivio')
                console.log(source)
                //aggiorna disponibilità quando il carrello viene aperto da archivio ordini
                this.$root.updateAvailability();
            }

            if (this.$root.shopCartData.prodotti.length == 0 && this.$root.shopCartData.id < 0) {
                this.isSyncing = true;
            }

            try {
                if( this.$root.shopCartData && this.$root.shopCartData.riferimento.length === 0 ){
                    var tempId = this.$root.getTempReferenceId();
                    this.riferimentoValue =  tempId;
                }else{
                    this.riferimentoValue =  this.$root.shopCartData.riferimento;
                }

                this.vsRiferimentoValue = this.$root.shopCartData.vostroRif;

                var tipoOrdineItem = this.tipoOrdineOptionsValue && this.tipoOrdineOptionsValue.length>0 ? this.tipoOrdineOptionsValue.find(o => o.type == this.$root.shopCartData.tipoOrdine ) : 'Standard';
                this.tipoOrdineValue = tipoOrdineItem != null ? tipoOrdineItem : this.tipoOrdineOptionsValue[0];
                for(var i=0; i<this.tipoOrdineOptionsValue.length;i++){
                    var o = this.tipoOrdineOptionsValue[i]
                    if(tipoOrdineItem && o.type == tipoOrdineItem.type){
                        this.scontoBaseValue = o.value
                        break
                    }else{
                        this.scontoBaseValue = this.$root.shopCartData.scontoBase
                    }
                }
                this.noteValue = this.$root.shopCartData.note;
                this.importoValue = this.$root.shopCartData.importo;

                this.refreshGrid();
                eventBus.$emit("cartFilled",this.$root.shopCartData.prodotti.length);
            } catch (err) {
                console.log(err)
            }
        },
        refreshGrid() {
            this.arrayToTable = [];

            var products = this.$root.shopCartData ? this.$root.shopCartData.prodotti : [];
            var importoValue = 0;

            for(var i = 0; i <products.length; i++){       
                var elem = products[i];   
                
                if(this.$Configs.useDiscountCategories){
                    if(this.riduzioneScontoValue || this.riduzioneScontoValue == 0){ //devo ricalcolare gli sconti sia quando la percentuale di riduzione ha un valore > 0 sia quando è 0 (ordine std) per tornare agli sconti iniziali
                        var scCliView = elem.scontoCliente - (elem.scontoCliente / 100 * this.riduzioneScontoValue),
                            scArtView = elem.scontoArticolo - (elem.scontoArticolo / 100 * this.riduzioneScontoValue)
                    }
                    var colSc = scCliView && scArtView ? scCliView + ' + ' + scArtView : scArtView ? scArtView : scCliView ? scCliView : ''
                    
                    var prezzoScCli = elem.prezzoOriginario - (elem.prezzoOriginario / 100 * scCliView)
                    var prezzoScCliArt = prezzoScCli - (prezzoScCli / 100 * scArtView)

                    elem.prezzoUnitario = prezzoScCliArt ? prezzoScCliArt.toFixed(2) : ''
                    elem.prezzoTotale = elem.quantita * elem.prezzoUnitario; 
                    importoValue += elem.prezzoTotale;
                }else{
                    if(this.scontoBaseValue || this.scontoBaseValue == 0){ //se è cambiato lo sconto base in relazione al tipo ordine, applico il nuovo sconto al prezzo originario e poi ri-applico lo sconto del profilo sconti(se c'è)
                        var scontatoBase = elem.prezzoOriginario - (elem.prezzoOriginario / 100 * this.scontoBaseValue)
                        var scontatoFinale = elem.discount ? scontatoBase - (scontatoBase / 100 * elem.discount) : scontatoBase
                    }
                    
                    elem.prezzoUnitario = scontatoFinale ? scontatoFinale.toFixed(2) : ''
                    elem.prezzoTotale = elem.quantita * elem.prezzoUnitario; 

                    importoValue += elem.prezzoTotale;
                }
                
                this.arrayToTable.push({
                    refObj: elem,
                    unitmis: this.$Jed.translate(elem.unitaMisura),
                    qty: '<i class="icon-modificare"></i> '+elem.quantita,
                    cod: elem.codiceProd, //il nuovo
                    sost: elem.codSost, //il vecchio
                    uprice: elem.prezzoUnitario,
                    totprice: (elem.prezzoTotale != 0 ? elem.prezzoTotale.toFixed(2): ''),
                    originprice: elem.prezzoOriginario,
                    descr: elem.descrizione,
                    csy: this.$root.token.valuta,
                    mqt: elem.mqt,
                    codlinea: elem.codlinea,
                    codmacch: elem.codmacch,
                    desmacch: elem.desmacch,
                    scArt: colSc,
                    noteRiga: '<i class="icon-modificare"> </i>'+ (elem.noteRiga ? elem.noteRiga : ''),
                    statoDis: elem.statoDisponibilità
                }) 
            }       
            if(this.$Behaviors.orderRowsDescending){
                this.arrayToTable.sort((a,b)=>{return ((a.cod < b.cod) ? 1 : ((a.cod > b.cod) ? -1 : 0))}); //ordinamento decrescente
            }else{
                this.arrayToTable.sort((a,b)=>{return ((a.cod > b.cod) ? 1 : ((a.cod < b.cod) ? -1 : 0))}); //ordinamento crescente
            }  
                            
            this.importoValue = importoValue.toFixed(2);  
            if(this.$root.shopCartData){
                this.$root.shopCartData.riferimento = this.riferimentoValue;
                this.$root.shopCartData.importo = this.importoValue;
                this.$root.shopCartData.scontoBase = this.scontoBaseValue;
            }
        },
        closePopups(){
            this.chooseQty = false
        },
        setRowNote(row, val){
            var thisProdInCart = this.$root.shopCartData.prodotti.find(x=>{
                return x.codiceProd == row.cod
            })
            thisProdInCart.noteRiga = val
            this.$root.saveDraft();
        },
        forwardClick () {
            if(this.arrayToTable.length==0){
                eventBus.$emit("alert", {type: "warning", message: this.$Jed.firstUpperTranslate('insert something in cart')});
                return;
            }
            this.$emit('changeComponentEvent', 2, this.getData());      
        },
        addProductClick () { 
            this.$emit('onOpenAddProductEvent', this.arrayToTable);      
        },
        loadFromExcelClick(){
            //imposto anche una nuova proprietà della struttura ShopCartData: 
            //$loki è la proprietà che non varia prima e dopo la sync bi-dir
            //userò $loki per recuperare il record dall'idb dopo la sync bi-dir
            //normalmente $loki viene settato alla saveCart ma in questo caso non la chiamo
            //quindi devo settare qui il $loki in modo che all'on "gotChanges" 
            //si aggiorni il carrello con il nuovo ordine e le nuove righeOrdine importate da excel
            console.log('loadFromExcelClick: ',this.riferimentoValue)
            if(this.riferimentoValue<0)this.$root.shopCartData.$loki = this.reg_orders.maxId+1
            this.$emit('onUploadFileEvent', this.riferimentoValue);
        },
        cleanShopCartClick () {
            this.$emit('onCleanShopCartEvent', '');      
        },
        changeStep: function(val) {  
            if( val != 1 )          
                this.$emit('changeComponentEvent',val, this.getData())  ;  
        },
        onOrderTypeChange: function(typeOrder) { //qui viene anche valorizzato il campo dello scontoBase
            if(typeOrder){
                if((typeOrder.type == 'Urgente' && this.$Configs.discountReductPerc)){ //se è stabilita una percentuale di riduzione sconto (TM Racing)
                    this.showScontoBase = false;
                    //devo ricalcolare entrambe le colonne che mostrano lo sconto articolo/cliente
                    //applicando la riduzione di sconto per l'ordine urgente: se è generica sta in discountReductPerc, se è specifica per cliente è nel value del typeOrder Urgente
                    this.riduzioneScontoValue = typeOrder.value ? typeOrder.value : this.$Configs.discountReductPerc
                }else{
                    this.riduzioneScontoValue = 0
                    this.showScontoBase = this.$Configs.discountReductPerc ? false : true;
                    this.scontoBaseValue = typeOrder.value ? typeOrder.value === 100.0 ? 0 : typeOrder.value : 0;
                }
                this.refreshGrid();
            }
        },
        getData() {
            console.log('GETDATA: ',this.$root.shopCartData)
            this.$root.shopCartData.riferimento = this.riferimentoValue;
            this.$root.shopCartData.vostroRif = this.vsRiferimentoValue;
            this.$root.shopCartData.tipoOrdine = this.tipoOrdineValue ? this.tipoOrdineValue.type : ''; 
            this.$root.shopCartData.note = this.noteValue;
            this.$root.shopCartData.scontoBase = this.scontoBaseValue;
            this.$root.shopCartData.importo = this.importoValue;
            
            return this.$root.shopCartData;
        },
        cartSend(){
            var vm = this;
            this.isSyncing = true
            var syncBefore = new Promise((resolve, reject)=>{
                if(!vm.$root.preferences.useOffline){
                    vm.$Sync.triggerUpdate() //nuova gestione sync nell'online
                    eventBus.$on('remoteSyncRegistryResolved',()=>{
                        console.log('OK sync 1st time - cart send to ecommerce')
                        resolve()
                    })
                }
            })
            syncBefore.then(()=>{
                console.log('THEN SYNC BEFORE - cart send to ecommerce')
                //call cmd only after resolving syncBefore promise
                this.$root
                    .microservice({
                        serviceType: "ext",
                        role: "ecommerce",
                        cmd: "SendCart",
                        params: {
                            orderId: vm.$root.shopCartData.id,
                            ecId: vm.$Configs.ecp.ecid,
                            userId: vm.$Configs.idUtente ? Number(vm.$Configs.idUtente) : null
                        }
                    }).then((response) => {
                        console.log(response)
                        if(response){
                            var res = response.body
                            /*response: {
                                ecCartUrl: '...'
                                errors: [{ // array di oggetti
                                    rowId: 6546546
                                    prodId: LHLHHSDDP4456, 
                                    message: 'Product Not Found' / "non sono riuscito a inserire questa riga nell’e-commerce"
                                }]
                            }*/
                            if(res.errors && res.errors.length>0){
                                //faccio la sync
                                //mostro un messaggio composto in base a response.errors
                                //se il numero di righe è diverso dal numero di errori
                                //  apro la pagina ecCartUrl se non è nullo o vuoto

                                if(!vm.$root.preferences.useOffline){
                                    vm.$Sync.triggerUpdate(); //nuova gestione sync nell'online
                                    eventBus.$on('remoteSyncRegistryResolved',()=>{
                                        console.log('OK sync 2nd time - cart send to ecommerce')
                                        vm.isSyncing = false
                                    })
                                }
                                
                                var message = ''
                                for(var i=0; i < res.errors.length; i++){
                                    message += res.errors[i].message + ', id: ' + res.errors[i].prodId + '<br> '
                                }
                                var ok = function(){
                                        this.close();
                                    },
                                    e = {
                                        message: message,
                                        ok: ok,
                                        YtxtBtn: this.$Jed.firstUpperTranslate('Ok')
                                    }
                                eventBus.$emit("confirm", e)

                                if(vm.$root.shopCartData.prodotti.length != res.errors.length){ //alcuni prodotti sono andati a buon fine
                                    if(res.ecCartUrl){
                                        window.open(res.ecCartUrl, '_blank');
                                    }
                                }
                            }else{
                                //se errors è nullo o vuoto
                                //  svuoto il carrello
                                //  apro la pagina ecCartUrl se non è nullo o vuoto
                                
                                vm.$emit('emptyShopCart', '');
                                
                                vm.isSyncing = false
                                
                                if(res.ecCartUrl){
                                    window.open(res.ecCartUrl, '_blank');
                                }
                            }  
                        }                                              
                    }, (error) => {
                
                        //vedi gestione errore in main.js > microservice

                    })
                    .catch(err => {
                        console.log(err);
                        var msg = err && err.body && err.body.error ? err.body.error : err
                        eventBus.$emit('alert', {
                            message: "Application caught an error <br> <h5>Details: " + "ext.ecommerce.SendCart - " + msg +'</h5>',
                            type: "error",
                            action: ''
                        })
                    })
            })
        }
    }
}
</script>

<style>

.v-select .selected-tag {
    margin-top: 0px;
}

.v-select .dropdown-toggle {
    display: flex !important;
    flex-wrap: wrap;
}

.v-select input[type=search], .v-select input[type=search]:focus {
    flex-basis: 20px;
    flex-grow: 1;
    margin-top: 0px;
    height: 28px;
    padding: 0 20px 0 10px;
    width: 100% !important;
}

</style>



// WEBPACK FOOTER //
// src/components/views/shopcart/ShopCart.vue?a94d075c